"use client"

import { useState, useEffect } from "react"

const EditModal = ({ show, onHide, editData, dropdownOptions, onSave, loading }) => {
  const [value, setValue] = useState("")

  useEffect(() => {
    if (editData?.currentValue) {
      setValue(editData.currentValue)
    }
  }, [editData])

  const handleSave = () => {
    onSave(editData?.billId, editData?.field, value)
  }

  if (!show) return null

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow">
          <div className="modal-header bg-light border-0 py-3">
            <h5 className="modal-title fw-bold" style={{ fontSize: "16px" }}>
              <i className="fa fa-edit me-2 text-primary"></i>
              Edit {editData?.fieldLabel}
            </h5>
            <button type="button" className="btn-close" onClick={onHide} style={{ fontSize: "12px" }}></button>
          </div>
          <div className="modal-body py-4">
            <div className="mb-3">
              <label className="form-label fw-semibold text-muted mb-2" style={{ fontSize: "12px" }}>
                {editData?.fieldLabel}
              </label>
              {editData?.field === "client" ||
              editData?.field === "package" ||
              editData?.field === "collected_by" ||
              editData?.field === "bank_account" ||
              editData?.field === "review_status" ||
              editData?.field === "status" ? (
                <select
                  className="form-select"
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  style={{ fontSize: "13px" }}
                >
                  <option value="">Select {editData?.fieldLabel}</option>
                  {dropdownOptions?.[editData?.field]?.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              ) : editData?.field === "billing_date" || editData?.field === "collection_date" ? (
                <input
                  type="datetime-local"
                  className="form-control"
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  style={{ fontSize: "13px" }}
                />
              ) : editData?.field === "amount" ? (
                <input
                  type="number"
                  className="form-control"
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  placeholder="Enter amount"
                  style={{ fontSize: "13px" }}
                />
              ) : (
                <input
                  type="text"
                  className="form-control"
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  placeholder={`Enter ${editData?.fieldLabel.toLowerCase()}`}
                  style={{ fontSize: "13px" }}
                />
              )}
            </div>
          </div>
          <div className="modal-footer border-0 py-3">
            <button
              type="button"
              className="btn btn-light"
              onClick={onHide}
              style={{ fontSize: "12px", padding: "8px 16px" }}
            >
              <i className="fa fa-times me-1"></i>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSave}
              disabled={loading}
              style={{ fontSize: "12px", padding: "8px 16px" }}
            >
              {loading ? (
                <>
                  <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                  Saving...
                </>
              ) : (
                <>
                  <i className="fa fa-save me-1"></i>
                  Save Changes
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditModal
